<template>
    <div class="news-main">
        <!-- 头部 -->
        <headers></headers>
        <div v-if="langluageType == 'ch'">
            <div class="about-nav-box">
                <section class="col" style="">
                    <div class="about-nav">
                        <a href="#p1" class="active" style="color: #333333;">企业简介</a>
                        <a href="#p2" style="color: #303133;">企业愿景</a>
                        <a href="#p3" style="color: #303133;">行业寄语</a>
                        <a href="#p4" style="color: #303133;">荣誉资质</a>
                        <!-- <a href="#p5" style="color: #303133;">发展历程</a> -->
                        <!-- <a href="#p6" style="color: #303133;">团队介绍</a> -->
                        <a href="#p7" style="color: #303133;">联系我们</a>
                    </div>

                </section>
            </div>
            <div id="p1" style="background: #fff;">

                <section class="col" style="padding-top: 200px;">
                    <h4 class="title3">企业简介</h4>
                    <p class="" style="width: 1200px; margin: 20px auto 100px; font-size: 20px; line-height: 40px; color: #303133;">
                        汇展供应链管理（北京）有限公司是一家专注于会展行业的创新型企业，主营业务包括：展览会议、主场运营、展位搭建等核心板块，致力于为客户提供全方位、一体化的会展服务体验。公司在北京、上海、成都、武汉等国内主要城市，已组建了完善的服务团队，凭借丰富的服务经验，精准把握客户需求，为会展活动的举办提供更好的服务和用户体验，让参展更省心！ 
                    </p>
                </section>
            </div>
            <div style="background: #F5F7FA;">
                <section class="col bg-map" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="margin-bottom: 40px; position: relative;">企业愿景<i id="p2" style="position:absolute; top:-150px"></i></h4>
                    <div class="qyyj" id="qyyj">
                        <div id="prev" class="btn-prev"></div>
                        <ul>
                            <li class="imgitem"><p>我们的企业价值观</p><span>真正的价值是维护好<br>参展商的利益</span> </li>
                            <li class="imgitem"><p>我们的Slogan和使命</p><span>让参展更省心!</span></li>
                            <li class="imgitem"><p>我们的经营目标</p><span>链接会展产业上下游<br>赋能行业中小微企业</span></li>
                            <li class="imgitem"><p>我们的企业价值观</p><span>真正的价值是维护好<br>参展商的利益</span> </li>
                            <li class="imgitem"><p>我们的Slogan和使命</p><span>让参展更省心!</span></li>
                            <li class="imgitem"><p>我们的经营目标</p><span>链接会展产业上下游<br>赋能行业中小微企业</span></li>
                        </ul>
                        <div id="next" class="btn-next"></div>
                    </div>
                </section>
            </div>
            <div id="" style="background: #fff;">
                <section class="col" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="position:relative;">行业寄语<i id="p3" style="position:absolute; top:-150px"></i></h4>
                    <ul class="list9">
                        <li>
                            <img src="../images/img-about-1.png" alt="">
                            <p>创始人陪同中国国际贸易促进委员会党组书记、中国国际商会会长姜增伟参观展会</p>
                        </li>
                        <li>
                            <img src="../images/img-about-2.png" alt="">
                            <p>创始人陪同原商务部副部长房爱卿参观展会</p>
                        </li>
                        <li>
                            <img src="../images/img-about-3.png" alt="">
                            <p>中国连锁经营协会会长 裴亮</p>
                        </li>
                        <li>
                            <img src="../images/img-about-4.png" alt="">
                            <p>全国工商联烘焙业公会副秘书长 张伟</p>
                        </li>
                    </ul>
                </section>
            </div>
            <div id="" style="background: #F5F7FA;">
                <section class="col ptry" style="padding-top: 50px; padding-bottom: 50px;text-align: center;">
                    <h4 class="title3" style="position:relative">平台荣誉<i id="p4" style="position:absolute; top:-150px"></i></h4>
                    <div style="display: flex;width: 1266px;align-items: center;justify-content: center;margin: 50px 0;">
                        <div style="display: flex; width: 322px;height: 380px;overflow: hidden;align-items: center;">
                            <img style="height: 259px;width: 342px;margin: 0;" src="../images/about-01.png" alt="">
                        </div>
                        <div style="width: 322px;height: 380px;margin: 0 60px;overflow: hidden;display: flex;align-items: center;justify-content: center;">
                            <img style="width: 322px;height: 380px;margin: 0;" src="../images/about-02.png" alt="">
                        </div>
                        <div style="width: 322px;height: 380px;overflow: hidden;display: flex;align-items: center;justify-content: center;">
                            <img style="width: 322px;height: 380px;margin: 0;" src="../images/about-03.png" alt="">
                        </div>
                    </div>
                    <!-- <div style="display: flex;width: 1266px;justify-content: center;">
                        <div style="width: 322px;height: 380px;overflow: hidden;">
                            <img style="width: 100%;height: 380px;margin: 0;" src="../images/about-04.png" alt="">
                        </div>
                        <div style="width: 322px;height: 380px;margin: 0 60px;overflow: hidden;">
                            <img style="width: 100%;height: 380px;margin: 0;" src="../images/about-05.png" alt="">
                        </div>
                        <div style="width: 322px;height: 380px;overflow: hidden;">
                            <img style="width: 100%;height: 380px;margin: 0;" src="../images/about-06.png" alt="">
                        </div>
                    </div> -->
                    
                </section>
            </div>
            <!-- <div id="" class="bg-line">
                <section class="col" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="position:relative">发展历程<i id="p5" style="position:absolute; top:-150px"></i></h4>
                    <div class="fzlc" id="fzlc">
                        <span>2016</span>
                        <span>2017</span>
                        <span>2018</span>
                        <span>2019</span>
                        <span>2020</span>
                        <span class="active">2021-2022</span>
                    </div>
                    <div class="fzlc-msg" id="fzlc-msg">
                        <div></div>
                        <p></p>
                    </div>
                </section>
            </div> -->
            <!-- <div id="" style="background: #fff;">
                <section class="col" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="position:relative">团队介绍<i id="p6" style="position:absolute; top:-150px"></i></h4>
                    <ul class="list10">
                        <li>
                            <img src="../images/img-about-9.png" alt="">
                            <div>吴 菲</div>
                            <span>创始人&CEO</span>
                            <p style="text-align: left">法国里昂商学院(物联网)工商管理硕士。全国会展工作委员会副秘书长，中国绿色会展联盟副秘书长，商务部会展业专家库成员，国家绿色环保展台行业标准评审专家、经济日报中国经济网特约作者，中国会展供应链和全渠道会展体系首创者。</p>
                        </li>
                        <li>
                            <img src="../images/img-about-10.png" alt="">
                            <div>庞 博</div>
                            <span>副总裁兼成都分公司总经理</span>
                            <p style="text-align: left">新西兰梅西大学市场营销专业。10余年会展管理经验，历任成都世纪城新国际会展中心营销运营部项目经理、研发部副总监、开发中心总监。承接各类型展会活动近百场，多项国家和行业标准主要起草人，曾担任武汉、郑州、济南等多个场馆项目运营咨询顾问。</p>
                        </li>
                        <li>
                            <img src="../images/img-about-11.png" alt="">
                            <div>胡向东</div>
                            <span>行政设计中心总监</span>
                            <p style="text-align: left">中央工艺美术学院服装艺术设计专业，专注于出版、包装、印刷领域，拥有20年品牌管理和广告实施专业经验。曾参与统筹规划与VIS实施传世画藏、1999世纪大阅兵、北京申奥音像制品、平章出版ERP等诸多品牌项目，完成50余场大型会展活动项目整体设计规划。</p>
                        </li>
                        <li>
                            <img src="../images/img-about-12.png" alt="">
                            <div>顾 飞</div>
                            <span>主场运营中心总监</span>
                            <p style="text-align: left">北京邮电大学计算机与技术专业，10余年展览会主场运营及管理经验，历任北京唯美创意国际展览服务有限公司项目经理、项目总监，CHINA PRINT、中国国际广播电视信息网络展览会、中国国际机床工具展览会等百场国家级展览会主场运营管理，拥有丰富的展会主场运营经验。</p>
                        </li>
                    </ul>
                </section>
            </div> -->
            <div id="" style="background: #fff;">
                <section class="col" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="position:relative">联系我们<i id="p7" style="position:absolute; top:-150px"></i></h4>
                    <div class="list11">
                        <div>
                            <p>商务洽谈</p>
                            <img src="../images/img-about-14.png" alt="">
                            <span>010-86460766-865</span>
                        </div>
                        <!-- <div>
                            <p>系统售后</p>
                            <img src="../images/img-about-13.png" alt="">
                            <span>010-86460766-861</span>
                        </div> -->
                        <div>
                            <p>主场服务</p>
                            <img src="../images/img-about-15.png" alt="">
                            <span>010-86460766-805</span>
                        </div>
                    </div>
                    <div class="list12">
                        <dl class="dl1">
                            <dt>ExpoSCM（会展供应链）北京总部</dt>
                            <!-- <dd><img src="../images/icon-address.png" alt=""><span>北京市朝阳区高碑店乡北花园金家村中街大地时尚文化创意园A座2009</span></dd> -->
                            <dd><img src="../images/icon-email.png" alt=""><span>info@exposcm.com</span></dd>
                        </dl>
                        <dl class="dl2">
                            <dt>ExpoSCM（会展供应链）武汉分公司</dt>
                            <!-- <dd><img src="../images/icon-address.png" alt=""><span>武汉市汉阳区经开未来城A栋1013</span></dd> -->
                            <dd><img src="../images/icon-email.png" alt=""><span>chengcheng@exposcm.com</span></dd>
                        </dl>
                        <dl class="dl1">
                            <dt>ExpoSCM（会展供应链）成都分公司</dt>
                            <!-- <dd><img src="../images/icon-address.png" alt=""><span>成都市高新区吉瑞一路200号航天城上城2期3栋701号</span></dd> -->
                            <dd><img src="../images/icon-email.png" alt=""><span>yingjie@exposcm.com</span></dd>
                        </dl>
                        <!-- <dl class="dl2">
                            <dt>ExpoSCM（会展供应链）上海办事处</dt>
                            <dd><img src="../images/icon-address.png" alt=""><span>上海市普陀区真北路2691号2栋2层201-31室</span></dd>
                            <dd><img src="../images/icon-email.png" alt=""><span>pangbo@exposcm.com</span></dd>
                        </dl> -->
                    </div>
                </section>
            </div>
        </div>
        <div v-else>
            <div class="about-nav-box">
                <section class="col" style="">
                    <div class="about-nav">
                        <a href="#p1" class="active">HoCompany Profileme</a>
                        <a href="#p2">Enterprise Vision</a>
                        <a href="#p4">Honours and Qualifications</a>
                        <!-- <a href="#p5">History</a> -->
                        <!-- <a href="#p6">Team</a> -->
                        <a href="#p7">Contact Us</a>
                    </div>

                </section>
            </div>
            <div id="p1" style="background: #fff;">

                <section class="col" style="padding-top: 200px;">
                    <h4 class="title3" style="color: #333333;font-size: 30px;">Company Profile</h4>
                    <p class="" style="width: 1200px; margin: 20px auto 100px; font-size: 20px; line-height: 40px; color: #303133;">
                        Huizhan Supply Chain Management (Beijing) Co., Ltd. is an innovative enterprise specializing in the exhibition industry. Its main business includes core areas such as exhibitions and conferences, home venue operations, and booth construction. It is committed to providing customers with a comprehensive and integrated exhibition service experience. The company has established a comprehensive service team in major domestic cities such as Beijing, Shanghai, Chengdu, and Wuhan. With rich service experience, we accurately grasp customer needs and provide better services and user experience for the organization of exhibitions and events, making participation more worry free!
                    </p>
                </section>
            </div>
            <div style="background: #F5F7FA;">
                <section class="col bg-map" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="margin-bottom: 40px; position: relative;color: #333333;font-size: 30px;">Corporate Vision<i id="p2" style="position:absolute; top:-150px"></i></h4>
                    <div class="qyyj" id="qyyj">
                        <div id="prev" class="btn-prev"></div>
                        <ul>
                            <li class="imgitem" style=""><p style="font-size: 11px;">Our Corporate Values</p></li>
                            <li class="imgitem"><p style="font-size: 11px;margin-bottom: 4px;">Our Slogan and Mission</p><span style="font-size: 11px;">To make attending trade<br>shows more hassle free!</span></li>
                            <li class="imgitem"><p style="font-size: 11px;">Our Business Objectives</p></li>
                            <li class="imgitem"><p style="font-size: 11px;">Our Corporate Values</p></li>
                            <li class="imgitem"><p style="font-size: 11px;margin-bottom: 4px;">Our Slogan and Mission</p><span style="font-size: 11px;">To make attending trade<br>shows more hassle free!</span></li>
                            <li class="imgitem"><p style="font-size: 11px;">Our Business Objectives</p></li>
                        </ul>
                        <div id="next" class="btn-next"></div>
                    </div>
                </section>
            </div>
            <div id="" style="background: #F5F7FA;">
                <section class="col ptry" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="position:relative;color: #333333;font-size: 30px;">Platform Honours<i id="p4" style="position:absolute; top:-150px"></i></h4>
                    <!-- <img src="../images/img-about-5-1.png" alt="">
                    <img src="../images/img-about-6-1.png" alt="">
                    <img src="../images/img-about-7-1.png" alt="">
                    <img src="../images/img-about-8-1.png" alt=""> -->
                    <div style="display: flex;width: 1266px;align-items: center;justify-content: center;margin: 50px 0;">
                        <div style="display: flex; width: 322px;height: 380px;overflow: hidden;align-items: center;">
                            <img style="height: 279px;width: 342px;margin: 0;" src="../images/444.png" alt="">
                        </div>
                        <div style="width: 322px;height: 380px;margin: 0 60px;overflow: hidden;display: flex;align-items: center;justify-content: center;">
                            <img style="width: 322px;height: 380px;margin: 0;" src="../images/about-02.png" alt="">
                        </div>
                        <div style="width: 322px;height: 380px;overflow: hidden;display: flex;align-items: center;justify-content: center;">
                            <img style="width: 322px;height: 380px;margin: 0;" src="../images/about-03.png" alt="">
                        </div>
                    </div>
                </section>
            </div>
            <!-- <div id="" class="bg-line">
                <section class="col" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="position:relative;color: #333333;font-size: 30px;">Milestones<i id="p5" style="position:absolute; top:-150px"></i></h4>
                    <div class="fzlc" id="fzlc">
                        <span>2016</span>
                        <span>2017</span>
                        <span>2018</span>
                        <span>2019</span>
                        <span>2020</span>
                        <span class="active">2021-2022</span>
                    </div>
                    <div class="fzlc-msg" id="fzlc-msg">
                        <div></div>
                        <p style="text-align: center;"></p>
                    </div>
                </section>
            </div> -->
            <!-- <div id="" style="background: #fff;">
                <section class="col" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="position:relative;color: #333333;font-size: 30px;">Team Introduction<i id="p6" style="position:absolute; top:-150px"></i></h4>
                    <ul class="list10">
                        <li>
                            <img src="../images/img-about-9.png" alt="">
                            <div>Wu Fei</div>
                            <span style="display: block;text-align: center;height: 55px;">Founder & CEO</span>
                            <p style="line-height: 26px;font-family: 思源宋体;text-align:left;">MBA (Internet of Things), Lyon Business School, France. Deputy Secretary General of National Exhibition Committee, Deputy Secretary General of China Green Exhibition Alliance, Member of Ministry of Commerce's Expert Pool of Exhibition Industry, Expert of National Green Booth Industry Standard Review, Contributing Writer of Economic Daily China Economy Network, Pioneer of China's Exhibition Supply Chain and Omni-Channel Exhibition System.</p>
                        </li>
                        <li>
                            <img src="../images/img-about-10.png" alt="">
                            <div>Pang Bo</div>
                            <span style="display: block;text-align: center;height: 55px;">Vice President and General Manager of Chengdu Branch</span>
                            <p style="line-height: 26px;font-family: 思源宋体;text-align:left;">Majoring in marketing at Massey University in New Zealand, Pang has more than 10 years of experience in exhibition management, and has served as project manager of the marketing and operation department of Chengdu Century City New International Convention and Exhibition Centre, deputy director of the research and development department, and director of the development centre. He has undertaken nearly 100 exhibitions and activities of various types, is the main drafter of many national and industry standards, and has served as a consultant for the operation of many venues in Wuhan, Zhengzhou, Jinan and other projects.</p>
                        </li>
                        <li>
                            <img src="../images/img-about-11.png" alt="">
                            <div>Hu Xiangdong</div>
                            <span style="display: block;text-align: center;height: 55px;">Director of Executive Design Centre</span>
                            <p style="line-height: 26px;font-family: 思源宋体;text-align:left;">Majoring in Fashion Art Design at the Central Academy of Arts and Crafts, Hu focuses on publishing, packaging and printing, and has 20 years of professional experience in brand management and advertising implementation. He has participated in the overall planning and VIS implementation of many branding projects, such as Heirloom Painting Collection, 1999 Century Parade, Beijing Olympic Games Audiovisual Products, Pingzhang Publishing ERP, etc. He has completed the overall design and planning of more than 50 large-scale exhibition and activity projects.</p>
                        </li>
                        <li>
                            <img src="../images/img-about-12.png" alt="">
                            <div>Gu Fei</div>
                            <span style="display: block;text-align: center;height: 55px;">Director of Main Venue Operation Centre</span>
                            <p style="line-height: 26px;font-family: 思源宋体;text-align:left;">Majoring in computer and technology at Beijing University of Posts and Telecommunications, he has more than 10 years of experience in exhibition venue operation and management, and has served as project manager and project director of Beijing Vimeo Creative International Exhibition Service Co., Ltd. and has rich experience in exhibition venue operation and management of hundreds of national exhibitions, such as CHINA PRINT, China International Broadcasting and Television Information Network Exhibition, and China International Machine Tool Exhibition.</p>
                        </li>
                    </ul>
                </section>
            </div> -->
            <div id="" style="background: #fff;">
                <section class="col" style="padding-top: 50px; padding-bottom: 50px;">
                    <h4 class="title3" style="position:relative;color: #333333;font-size: 30px;">Team Introduction<i id="p7" style="position:absolute; top:-150px"></i></h4>
                    <div class="list11">
                        <div style="padding: 50px 40px;">
                            <p>Business negotiation</p>
                            <img src="../images/img-about-14.png" alt="">
                            <span>010-86460766-865</span>
                        </div>
                        <!-- <div style="padding: 50px 40px;">
                            <p>After-sales service</p>
                            <img src="../images/img-about-13.png" alt="">
                            <span>010-86460766-861</span>
                        </div> -->
                        <div style="padding: 50px 40px;">
                            <p>Main Service</p>
                            <img src="../images/img-about-15.png" alt="">
                            <span>010-86460766-805</span>
                        </div>
                    </div>
                    <div class="list12" style="flex-wrap: wrap;">
                        <dl class="dl1" style="width: 50%;padding: 50px 50px 0 30px;">
                            <dt>ExpoSCM (Exhibition Supply Chain) Beijing Headquarter</dt>
                            <dd style="line-height: normal;align-items: normal;"><img style="margin-top: 2px;" src="../images/icon-address.png" alt=""><span>2009, Block A, Dadi Fashion Culture and Creative Park, Jinjiacun Middle Street, Gaobeidian Township, Chaoyang District, Beijing, China.</span></dd>
                            <dd><img style="margin-top: 2px;" src="../images/icon-email.png" alt=""><span>info@exposcm.com</span></dd>
                        </dl>
                        <dl class="dl2" style="width: 50%;padding: 50px 30px 0 50px;">
                            <dt style="margin-bottom: 40px;">ExpoSCM Wuhan Branch Office</dt>
                            <dd style="line-height: normal;align-items: normal;margin-bottom: 48px;"><img style="margin-top: 2px;" src="../images/icon-address.png" alt=""><span>2701 Mujinxingguang, Hanyang District, Wuhan, China</span></dd>
                            <dd style="line-height: normal;align-items: normal;"><img style="margin-top: 2px;" src="../images/icon-email.png" alt=""><span>chengcheng@exposcm.com</span></dd>
                        </dl>
                        <dl class="dl1" style="width: 50%;padding: 50px 50px 0 30px;">
                            <dt>ExpoSCM (MICE Supply Chain) Chengdu Branch Office</dt>
                            <dd style="line-height: normal;align-items: normal;"><img style="margin-top: 2px;" src="../images/icon-address.png" alt=""><span>No.701, Building 3, Phase 2, Aerospace City Uptown, No.200 Ji Rui Yi Road, Gao Xin District, Chengdu, China</span></dd>
                            <dd><img style="margin-top: 2px;" src="../images/icon-email.png" alt=""><span>yingjie@exposcm.com</span></dd>
                        </dl>
                        <!-- <dl class="dl2" style="width: 50%;padding: 50px 30px 0 50px;">
                            <dt style="margin-bottom: 40px;">ExpoSCM Shanghai Office</dt>
                            <dd style="line-height: normal;align-items: normal;"><img style="margin-top: 2px;" src="../images/icon-address.png" alt=""><span>Room 201-31, 2/F, Building 2, No.2691 Zhenbei Road, Putuo District, Shanghai, China</span></dd>
                            <dd><img style="margin-top: 2px;" src="../images/icon-email.png" alt=""><span>pangbo@exposcm.com</span></dd>
                        </dl> -->
                    </div>
                </section>
            </div>
        </div>
        
         <!-- 尾部 -->
        <footers></footers>
        <!-- 右侧吸附客服咨询按钮 -->
        <contact></contact>
    </div>
</template>
    <script>
    import $ from 'jquery';
    import headers from '@/common/header';
    import footers from '@/common/Footer';
    import contact from '@/components/contact';
    export default {
        components: {
            headers,
            footers,
            contact
        },
        data(){
            return {
                langluageType:sessionStorage.getItem('langluageType')||'ch',
            }
        },
        mounted() {
            var _fzlc = null
        // 发展历程
        if(this.langluageType == 'ch'){
            _fzlc = {
                2016:{
                    label: '平台初创',
                    msg: `自主研发主场云1.0<br>
                        自主研发会展商城1.0`
                },
                2017:{
                    label: '服务创新',
                    msg: `数字化赋能主场服务<br>
                        平台用户突破千`
                },
                2018:{
                    label: '技术拓展',
                    msg: `自主研发物流云1.0<br>
                        主场云拓展移动端迭代2.0`
                },
                2019:{
                    label: '平台延伸',
                    msg: `自主研发招展云、观众云1.0<br>
                        自主研发展装云、设计云1.0`
                },
                2020:{
                    label: '技术突破',
                    msg: `主场云深度拓展场景迭代3.0<br>
                        同步优化全平台产品`
                },
                '2021-2022':{
                    label: '逆境创新',
                    msg: `累计平台用户数破万<br>
                        累计报馆量超过三万<br>
                        同步迭代全平台产品`
                },
            }
        }else{
            _fzlc = {
                2016:{
                    label: 'Platform start-up',
                    msg: `Self-developed ExpoWork 1.0<br>
                        Self-developed Exhibition Mall Platform 1.0`
                },
                2017:{
                    label: 'Service Innovation',
                    msg: `Digital empowerment of the main business services<br>
                        Thousands of platform users`
                },
                2018:{
                    label: 'Technology Expansion',
                    msg: `Self-developed ExpoCarGo 1.0<br>
                        ExpoWork added mobile iteration 2.0`
                },
                2019:{
                    label: 'Platform Extension',
                    msg: `Self-developed ExpoCRM, ExpoGuest 1.0<br>
                        Self-developed ExpoProject, ExpoDesign1.0`
                },
                2020:{
                    label: 'Technology Breakthroughs',
                    msg: `ExpoWork Deep Expansion Scenario Iteration 3.0<br>
                        Simultaneous optimisation of all platform products`
                },
                '2021-2022':{
                    label: 'Innovation Against All Odds',
                    msg: `Cumulative number of platform users exceeded 10,000<br>
                        Cumulative enrolment exceeds 30,000<br>
                        Simultaneous iteration of all platform products`
                },
            }
        }
        $('#fzlc-msg>div').html(_fzlc['2021-2022'].label)
        $('#fzlc-msg>p').html(_fzlc['2021-2022'].msg)
        $('#fzlc span').hover(function(){
            $(this).addClass('active').siblings('span').removeClass('active')
            var time = $(this).text()
            // console.log(time)
            $('#fzlc-msg>div').html(_fzlc[time].label)
            $('#fzlc-msg>p').html(_fzlc[time].msg)
        })
        // 企业愿景
        var cur, pre, next;
        var imgDoms = $('.imgitem');
        initImg();

        function initImg() {
            pre = 0;
            cur = 1;
            next = 2;
            $(imgDoms[pre]).addClass('pre-img');
            $(imgDoms[cur]).addClass('cur-img');
            $(imgDoms[next]).addClass('next-img');
        }
        $('#qyyj').on('click','#prev, .pre-img',function() {
            pre = pre - 1;
            cur = cur - 1;
            next = next - 1;
            if (next < 0) {
                next = imgDoms.length - 1;
            }
            if (cur < 0) {
                cur = imgDoms.length - 1;
            }
            if (pre < 0) {
                pre = imgDoms.length - 1;
            }
            $('.cur-img').removeClass('cur-img');
            $(imgDoms[cur]).addClass('cur-img');

            $('.pre-img').removeClass('pre-img');
            $(imgDoms[pre]).addClass('pre-img');

            $('.next-img').removeClass('next-img');
            $(imgDoms[next]).addClass('next-img');
        })
        $('#qyyj').on('click','#next, .next-img', function() {
            pre += 1;
            cur += 1;
            next += 1;
            if (next > imgDoms.length - 1) {
                next = 0
            }
            if (cur > imgDoms.length - 1) {
                cur = 0
            }
            if (pre > imgDoms.length - 1) {
                pre = 0
            }
            $('.cur-img').removeClass('cur-img');
            $(imgDoms[cur]).addClass('cur-img');

            $('.pre-img').removeClass('pre-img');
            $(imgDoms[pre]).addClass('pre-img');

            $('.next-img').removeClass('next-img');
            $(imgDoms[next]).addClass('next-img');
        })



        $('.about-nav').on('click', 'a', function () {
            $(this).addClass('active').siblings('a').removeClass('active')
        })
        var h2 = $( "#p2" ).offset().top - 150;
        var h3 = $( "#p3" ).offset().top - 150;
        var h4 = $( "#p4" ).offset().top - 150;
        var h5 = $( "#p5" ).offset().top - 150;
        var h6 = $( "#p6" ).offset().top - 150;
        var h7 = $( "#p7" ).offset().top - 150;
        var md_timer = null
        $(document).scroll(function() {
            var scroH = $(document).scrollTop();  //滚动高度
            var viewH = $(window).height();  //可见高度
            var contentH = $(document).height();  //内容高度

            if(md_timer){
                clearTimeout(md_timer)
            }
            md_timer = setTimeout(function(){
                if(scroH > h7){  //距离顶部大于100px时
                    $('a[href="#p7"]').addClass('active').siblings('a').removeClass('active')
                    
                }else if(scroH > h6){  //距离顶部大于100px时
                    $('a[href="#p6"]').addClass('active').siblings('a').removeClass('active')
                    
                }else if(scroH > h5){  //距离顶部大于100px时
                    $('a[href="#p5"]').addClass('active').siblings('a').removeClass('active')
                    
                }else if(scroH > h4){  //距离顶部大于100px时
                    $('a[href="#p4"]').addClass('active').siblings('a').removeClass('active')
                    
                }else if(scroH > h3){
                    $('a[href="#p3"]').addClass('active').siblings('a').removeClass('active')
                }else if(scroH > h2){
                    $('a[href="#p2"]').addClass('active').siblings('a').removeClass('active')
                }else{
                    $('a[href="#p1"]').addClass('active').siblings('a').removeClass('active')
                }
            }, 600)
        });
    }
}
    </script>
    <style scoped>
    .pre-img p{
        text-align: center !important;
        font-size: 13px !important;
    }
    .next-img p{
        text-align: center !important;
        font-size: 13px !important;
    }
    </style>


// WEBPACK FOOTER //
// src/page/about.vue